import { Navigation, NavOptions, SettingsLoader, StringUtil, UrlUtil, UserSettings } from "@mcleod/core";
import { Layout, MainPageAccessor, Snackbar } from "@mcleod/components";
import { PageHeader } from "./pageheader/PageHeader";
import { Router } from "./router/Router";

export class UserLayoutProvider {
    private static singleton: UserLayoutProvider;

    public static get(): UserLayoutProvider {
        this.initialize();
        return this.singleton;
    }

    public static set(provider: UserLayoutProvider) {
        this.singleton = provider;
    }

    static initialize() {
        // If a provider has not been supplied for a specific web app, use the common one (this class).
        if (this.singleton == null)
            this.singleton = new UserLayoutProvider();
    }

    get layoutPath(): string {
        return "common/user/User";
    }

    public static navigateTo(overrideUserId?: string, navOptions?: Partial<NavOptions>, props?: any) {
        const userId = StringUtil.isEmptyString(overrideUserId) ? UserSettings.getUserId() : overrideUserId;
        const params: string[] = [
            "mode=update",
            `key=${userId}`
        ];
        const url = this.singleton.layoutPath + UrlUtil.buildQueryString(params);
        Navigation.navigateTo(url, navOptions, props);
    }

    public static refreshSettings(layout: Layout, showSnackbar: boolean = true) {
        if (showSnackbar) {
            Snackbar.showDownloadSnackbar("Settings Refresh",
                "Please wait while the updated settings take effect...",
                { persist: true, id: "settingsRefresh", targetPanel: MainPageAccessor.router }
            );
        }
        layout.displayInViewMode();
        setTimeout(() => {
            SettingsLoader.loadAuthSettings(
                null,
                () => this.doAfterSettingsRefresh(),
                null
            );
        }, 2500);
    }

    private static doAfterSettingsRefresh() {
        PageHeader.instance.clearMenu();
        Router.instance.redisplayCurrentRoute();
    }
}
